var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import AsyncStorage from '@react-native-async-storage/async-storage';
import { injectable } from '../../Decorators/Injectable';
import { Platform } from 'react-native';
let StorageDataSource = class StorageDataSource {
    stringify(value) {
        if (typeof value === 'string') {
            return value;
        }
        return JSON.stringify(value);
    }
    parse(value) {
        if (value === null || value === undefined) {
            return null;
        }
        if (value.startsWith('{') || value.startsWith('[')) {
            return JSON.parse(value);
        }
        return value;
    }
    getIsSupported() {
        if (Platform.OS !== 'web') {
            this.isSupported = true;
            return Promise.resolve(this.isSupported);
        }
        if (typeof this.isSupported === 'boolean') {
            return Promise.resolve(this.isSupported);
        }
        return new Promise((res) => {
            try {
                if (!window.localStorage) {
                    this.isSupported = false;
                    res(this.isSupported);
                    return;
                }
                const x = '__storage_test__';
                window.localStorage.setItem(x, x);
                window.localStorage.removeItem(x);
                this.isSupported = true;
                res(this.isSupported);
            }
            catch (err) {
                this.isSupported = false;
                res(this.isSupported);
            }
        });
    }
    set(key, value) {
        return this.getIsSupported()
            .then(hasAccess => {
            if (!hasAccess) {
                return value;
            }
            if (value === undefined || value === null) {
                return this.remove(key);
            }
            const str = this.stringify(value);
            return AsyncStorage.setItem(key, str).then(() => value);
        });
    }
    get(key) {
        return this.getIsSupported()
            .then(hasAccess => {
            return hasAccess
                ? AsyncStorage.getItem(key).then(value => this.parse(value))
                : null;
        });
    }
    remove(key) {
        return this.getIsSupported()
            .then(hasAccess => {
            return hasAccess
                ? AsyncStorage.removeItem(key).then(() => null)
                : null;
        });
    }
};
StorageDataSource = __decorate([
    injectable({ type: 'singleton' })
], StorageDataSource);
export { StorageDataSource };
